import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-country';
const API_DETAIL = (id: number) => `/p-country/${id}`;

export interface PCountry {
  id: number;
  pc_descr?: string;
}

export const usePCountrys = (searchParams?: string) => {
  const params = new URLSearchParams({ manage: '1' });
  if (searchParams) params.set('searchParams', searchParams);
  const queryString = `?${params.toString()}`;
  const { data, error, isLoading, mutate } = useSWR<PCountry[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    pCountrys: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePCountry = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<PCountry>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    pCountry: data,
    isLoading,
    isError: error,
    mutate,
  };
};
